var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19271",
    "data-name": "Gruppe 19271",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19267",
    "data-name": "Gruppe 19267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284051",
    "data-name": "Pfad 284051",
    d: "M34.822,19.113l-3.536-3.535a.575.575,0,0,0-.812,0l-13.68,13.68a.569.569,0,0,0-.158.3l-.817,4.351a.577.577,0,0,0,.565.682.634.634,0,0,0,.106-.01l4.352-.816a.575.575,0,0,0,.3-.16L34.822,19.926a.573.573,0,0,0,0-.813ZM20.456,32.667,17.1,33.3l.629-3.351,10.2-10.2,1.677,1.677a.575.575,0,1,0,.813-.813l-1.677-1.677L30.88,16.8,33.6,19.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19269",
    "data-name": "Gruppe 19269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19268",
    "data-name": "Gruppe 19268"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24680",
    "data-name": "Rechteck 24680",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19270",
    "data-name": "Gruppe 19270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284052",
    "data-name": "Pfad 284052",
    d: "M34.5,35.075h-10a.575.575,0,0,1,0-1.15h10a.575.575,0,0,1,0,1.15Z",
    fill: "#1d1d1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.c9342f807e071379095a5a9715b6d9c2.svg";
export { ForwardRef as ReactComponent };